import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TranslateModule } from '@ngx-translate/core';

import { TimezoneSelectorComponent } from './timezone-selector.component';
import { MatButtonModule } from '@angular/material/button';
export { TimezoneSelectorComponent } from './timezone-selector.component';

export const MODULE_IMPORTS = [
  CommonModule,
  MatIconModule,
  MatButtonModule,
  MatInputModule,
  MatAutocompleteModule,
  ReactiveFormsModule,
  GalaxyInputModule,
  TranslateModule,
  GalaxyFormFieldModule,
];

export const MODULE_DECLARATIONS = [TimezoneSelectorComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  exports: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
})
export class GalaxyTimezoneSelectorModule {}
